import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  addOperatingAutorities,
  getFees,
  getFeesAndInvoices,
  getFeesAndInvoicesReceived,
  getFeesRecieved,
  getPaymentHistoryReceived,
  getInvoices,
  getInvoicesFailed,
  getInvoicesRecieved,
  getOperatingAuthoritiesFailed,
  getOperatingAuthoritiesReceived,
  getOperatingAutorities,
  getPaymentHistory,
  getPaymentHistoryRecievedFailed,
  getNotifications,
  getNotificationsReceived,
  getNotificationsFailed,
  editOperatingAuthorities,
  editOperatingAuthoritiesFailed,
  editOperatingAuthoritiesReceived,
  getTerminals,
  getTerminalsReceived,
  getTerminalsFailed,
  getEvents,
  getEventsReceived,
  getEventsFailed,
  addEvent,
  addEventFailed,
  editEvent,
  editEventFailed,
  terminateEvent,
  terminateEventFailed,
  getReturningGuests,
  getReturningGuestsReceived,
  getReturningGuestsFailed,
  editReturningGuest,
  editReturningGuestFailed,
  addReturningGuest,
  addReturningGuestFailed,
  deleteReturningGuest,
  deleteReturningGuestFailed,
  addEventReceived,
  showPopup,
  addOperatingAutoritiesReceived,
  showApplicationInfoPopup,
  showApplicationInfoPopupList,
  getNotificationMessage,
  getNotificationMessageReceived,
  getNotificationMessageFailed,
} from '../actions/operatingAuthorityAction';
import { catchError, map, mergeMap, of } from 'rxjs';
import { OperatingAuthorityService } from '../../core/services/operatingAuthority/operating-authority.service';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import { Injectable } from '@angular/core';
import { fetchCompanyData } from '../actions/companyAction';

@Injectable()
export class operatingAuthorityEffect {
  constructor(
    private actions: Actions,
    private OpService: OperatingAuthorityService,
    private snackbarService: SnackbarService,
  ) {}
  operatingAuthorityEffectDetails$ = createEffect(() =>
    this.actions.pipe(
      ofType(
        getOperatingAutorities,
        getOperatingAuthoritiesReceived,
        getFeesAndInvoices,
        addOperatingAutorities,
        getFees,
        getInvoices,
        getPaymentHistory,
        getNotifications,
        getNotificationMessage,
        editOperatingAuthorities,
        getTerminals,
        getEvents,
        addEvent,
        editEvent,
        terminateEvent,
        getReturningGuests,
        addReturningGuest,
        editReturningGuest,
        deleteReturningGuest,
      ),
      mergeMap((params) => {
        const userData: any = JSON.parse(
          localStorage.getItem('userData') || '',
        );
        if (params.type === 'get-OperatinAuthorities') {
          return this.OpService.getOperatingAuthorityRecords(
            userData?.sessionHash,
            params.params,
          ).pipe(
            map((data: any) => {
              return getOperatingAuthoritiesReceived({
                params: data,
              });
            }),
            catchError((error) => of(getOperatingAuthoritiesFailed())),
          );
        } else if (params.type === 'get-fees') {
          return this.OpService.getFees(params.params).pipe(
            map((data: any) => {
              return getFeesRecieved({
                params: data,
              });
            }),
            catchError((error) => of(getOperatingAuthoritiesFailed())),
          );
        } else if (params.type === 'get-invoices') {
          return this.OpService.getInvoices(params.params).pipe(
            map((data: any) => {
              return getInvoicesRecieved({
                params: data,
              });
            }),
            catchError((error) => of(getInvoicesFailed())),
          );
        } else if (params.type === 'get-fees-and-invoices') {
          return this.OpService.getFeesAndInvoices(params.params).pipe(
            map((data: any) => {
              return getFeesAndInvoicesReceived({
                params: data,
              });
            }),
            catchError((error) => of(getOperatingAuthoritiesFailed())),
          );
        } else if (params.type === 'get-payment-history') {
          return this.OpService.getPaymentHistory(params.params).pipe(
            map((data: any) => {
              return getPaymentHistoryReceived({
                params: data,
              });
            }),
            catchError((error) => of(getPaymentHistoryRecievedFailed())),
          );
        } else if (params.type === 'add-OperatingAuthorities') {
          return this.OpService.addOperatingAuthoritiesService(
            params,
            userData?.sessionHash,
          ).pipe(
            mergeMap((data: any) => {
              this.snackbarService.success(
                'DFW Authority has been added successfully',
              );
              return params.OAType
                ? of(
                    addOperatingAutoritiesReceived({ params: data }),
                    showApplicationInfoPopupList({ params: true }),
                  )
                : of(
                    fetchCompanyData({
                      sessionHash: userData?.sessionHash,
                    }),
                    addOperatingAutoritiesReceived({ params: data }),
                    showApplicationInfoPopup({ params: true }),
                  );
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return params.OAType
                ? of(
                    getOperatingAutorities({ params: '' }),
                    showApplicationInfoPopupList({ params: false }),
                  )
                : of(
                    fetchCompanyData({ sessionHash: userData?.sessionHash }),
                    showApplicationInfoPopup({ params: false }),
                  );
            }),
          );
        } else if (params.type === 'edit-OperatingAuthorities') {
          return this.OpService.editOperatingAuthoritiesService(
            params,
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              this.OpService.getOperatingAuthorityRecordsById(
                userData?.sessionHash,
                params.params.permitId,
              ).subscribe((updatedData) => {
                this.snackbarService.success(
                  'DFW Authority has been updated successfully',
                );
                this.OpService.selectedOAdata = updatedData;
              });
              return editOperatingAuthoritiesReceived();
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(editOperatingAuthoritiesFailed());
            }),
          );
        } else if (params.type === 'get-notifications') {
          return this.OpService.getNotificationsService(
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              return getNotificationsReceived({
                params: data,
              });
            }),
            catchError((error) => of(getNotificationsFailed())),
          );
        } else if (params.type === 'get-notification-message') {
          return this.OpService.getNotificationMessage(params.params).pipe(
            map((data: any) => {
              return getNotificationMessageReceived({
                params: data,
              });
            }),
            catchError((error) => of(getNotificationMessageFailed())),
          );
        } else if (params.type === 'get-terminals') {
          return this.OpService.getTerminalsService(userData?.sessionHash).pipe(
            map((data: any) => {
              return getTerminalsReceived({
                params: data,
              });
            }),
            catchError((error) => of(getTerminalsFailed())),
          );
        } else if (params.type === 'get-events') {
          return this.OpService.getEventsService(params.params).pipe(
            map((data: any) => {
              return getEventsReceived({
                params: data,
              });
            }),
            catchError((error) => of(getEventsFailed())),
          );
        } else if (params.type === 'add-event') {
          return this.OpService.addEventService(
            params,
            userData?.sessionHash,
          ).pipe(
            mergeMap((data: any) => {
              this.snackbarService.success(
                'DFW Authority Event has been added successfully',
              );
              const payload: any = {
                sessionHash: userData?.sessionHash,
                permitId: this.OpService.selectedOAdata.permitId,
              };
              return of(
                getEvents({ params: payload }),
                addEventReceived({ params: data }),
                showPopup({ params: true }),
              );
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(addEventFailed(), showPopup({ params: false }));
            }),
          );
        } else if (params.type === 'edit-event') {
          return this.OpService.editEventService(
            params,
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'DFW Authority Event has been updated successfully',
              );
              const payload: any = {
                sessionHash: userData?.sessionHash,
                permitId: this.OpService.selectedOAdata.permitId,
              };
              return getEvents({ params: payload });
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(editEventFailed());
            }),
          );
        } else if (params.type === 'terminate-event') {
          return this.OpService.terminateEventService(
            params,
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'DFW Authority Event has been terminated successfully',
              );
              return getEvents({ params: data });
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(terminateEventFailed());
            }),
          );
        } else if (params.type === 'returning-guests') {
          return this.OpService.getReturningGuestsService(params.params).pipe(
            map((data: any) => {
              return getReturningGuestsReceived({
                params: data,
              });
            }),
            catchError((error) => of(getReturningGuestsFailed())),
          );
        } else if (params.type === 'add-returning-guest') {
          return this.OpService.addReturningGuestService(
            params,
            userData?.sessionHash,
          ).pipe(
            mergeMap((data: any) => {
              this.snackbarService.success(
                'DFW Authority Event Returning Guest has been added successfully',
              );
              const payload: any = {
                sessionHash: userData?.sessionHash,
                requestId: params.params.requestId,
              };
              return of(
                getReturningGuests({ params: payload }),
                showPopup({ params: true }),
              );
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(
                addReturningGuestFailed(),
                showPopup({ params: false }),
              );
            }),
          );
        } else if (params.type === 'edit-returning-guest') {
          return this.OpService.editReturningGuestService(
            params,
            userData?.sessionHash,
          ).pipe(
            map((data: any) => {
              this.snackbarService.success(
                'DFW Authority Event Returning Guest has been updated successfully',
              );
              const payload: any = {
                sessionHash: userData?.sessionHash,
                requestId: params.requestId,
              };
              return getReturningGuests({ params: payload });
            }),
            catchError((error) => {
              this.snackbarService.danger(error);
              return of(editReturningGuestFailed());
            }),
          );
        } else if (params.type === 'delete-returning-guest') {
          return this.OpService.deleteReturningGuestService(params.params).pipe(
            map((data) => {
              this.snackbarService.danger(
                'DFW Authority Event Returning Guest has been deleted successfully',
              );
              const payload: any = {
                sessionHash: userData?.sessionHash,
                requestId: params.requestId,
              };
              return getReturningGuests({ params: payload });
            }),
            catchError((error) => {
              this.snackbarService.handleError(error.message);
              return of(deleteReturningGuestFailed());
            }),
          );
        }
        return of({ type: '[Company API] Unknown Action' });
      }),
    ),
  );
}
